// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3efKk","col":"styles_col__1fnC8"};